import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { VeliDashboard } from './components/VeliDashboard';
import { VeliDersProgrami } from './components/VeliDersProgrami';
import { VeliHeader } from './components/VeliHeader';
import { VeliClock } from './components/VeliClock';
import { VeliSidebar } from './components/VeliSidebar';
import { VeliMessages } from './components/VeliMessages';
import { VeliOdevlerim } from './components/VeliOdevlerim';
import { VeliDenemeAnalizleri } from './components/VeliDenemeAnalizleri';
import { VeliProfil } from './components/VeliProfil';
import { VeliAbonelikBilgileri } from './components/VeliAbonelikBilgileri';
import { VeliBildirimler } from './components/VeliBildirimler';
export function App() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <div className="min-h-screen w-full bg-[#080808] text-white" data-id="element-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6" data-id="element-1">
        <div className="flex flex-col space-y-6" data-id="element-2">
          {/* Üst Header Kısmı */}
          <div className="flex flex-col items-center space-y-4" data-id="element-3">
            <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0" data-id="element-4">
              <h1 className="text-2xl font-bold text-center sm:text-left" data-id="element-5">
                Hoş geldiniz, <span className="text-blue-400" data-id="element-6">Ahmet Bey</span>
              </h1>
              <div className="flex justify-center sm:justify-end" data-id="element-7">
                <VeliHeader isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} data-id="element-8" />
              </div>
            </div>
            <VeliClock data-id="element-9" />
          </div>
          {/* Ana İçerik */}
          <div className="flex flex-col md:flex-row gap-6" data-id="element-10">
            <VeliSidebar isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} data-id="element-11" />
            <main className="flex-1 min-w-0" data-id="element-12">
              <Routes data-id="element-13">
                <Route path="/" element={<VeliDashboard data-id="element-15" />} data-id="element-14" />
                <Route path="/deneme-analizleri" element={<VeliDenemeAnalizleri data-id="element-17" />} data-id="element-16" />
                <Route path="/odev-takibi" element={<VeliOdevlerim data-id="element-19" />} data-id="element-18" />
                <Route path="/ders-programi" element={<VeliDersProgrami data-id="element-21" />} data-id="element-20" />
                <Route path="/mesajlarim" element={<VeliMessages data-id="element-23" />} data-id="element-22" />
                <Route path="/profil" element={<VeliProfil data-id="element-25" />} data-id="element-24" />
                <Route path="/abonelik-bilgileri" element={<VeliAbonelikBilgileri data-id="element-27" />} data-id="element-26" />
                <Route path="/bildirimler" element={<VeliBildirimler data-id="element-29" />} data-id="element-28" />
              </Routes>
            </main>
          </div>
        </div>
      </div>
    </div>;
}